var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~dashboard-dashboard-module~details-details-module~monitors-monitors-module~new-dashboard-new~259bb16c",
		"default~dashboard-dashboard-module~new-dashboard-new-dashboard-module~reports-reports-module",
		"default~dashboard-dashboard-module~new-dashboard-new-dashboard-module",
		"default~dashboard-dashboard-module~details-details-module",
		"common",
		"dashboard-dashboard-module"
	],
	"./details/details.module": [
		"./src/app/details/details.module.ts",
		"default~dashboard-dashboard-module~details-details-module~monitors-monitors-module~new-dashboard-new~259bb16c",
		"default~dashboard-dashboard-module~details-details-module",
		"common",
		"details-details-module"
	],
	"./extras/authentication.modules": [
		"./src/app/extras/authentication.modules.ts",
		"extras-authentication-modules"
	],
	"./monitors/monitors.module": [
		"./src/app/monitors/monitors.module.ts",
		"default~dashboard-dashboard-module~details-details-module~monitors-monitors-module~new-dashboard-new~259bb16c",
		"common",
		"monitors-monitors-module"
	],
	"./new-dashboard/new-dashboard.module": [
		"./src/app/new-dashboard/new-dashboard.module.ts",
		"default~dashboard-dashboard-module~details-details-module~monitors-monitors-module~new-dashboard-new~259bb16c",
		"default~dashboard-dashboard-module~new-dashboard-new-dashboard-module~reports-reports-module",
		"default~dashboard-dashboard-module~new-dashboard-new-dashboard-module",
		"common",
		"new-dashboard-new-dashboard-module"
	],
	"./oprations/oprations.module": [
		"./src/app/oprations/oprations.module.ts",
		"default~dashboard-dashboard-module~details-details-module~monitors-monitors-module~new-dashboard-new~259bb16c",
		"common",
		"oprations-oprations-module"
	],
	"./orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"common",
		"orders-orders-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"default~dashboard-dashboard-module~new-dashboard-new-dashboard-module~reports-reports-module",
		"common",
		"reports-reports-module"
	],
	"./users/user.module": [
		"./src/app/users/user.module.ts",
		"default~dashboard-dashboard-module~details-details-module~monitors-monitors-module~new-dashboard-new~259bb16c",
		"common",
		"users-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;